import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { RackeoLocaleService, RackeoHomeData, RackeoContactData } from '../shared/services/locale.service';
import { MetaService } from '@ngx-meta/core';
import { URL } from '../../environments/environment';
import { CanonicalService } from '../shared/services/canonical.service';
import { RACKEO_SITE } from '../shared/rackeo-site';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  private readonly defaultHome: RackeoHomeData = {
    heroImage: 'assets/images/rackeo/inicio/hero-plataforma-nube.png',
    heroAlt: 'Plataforma Cloud Rackeo: hosting, VPS y servidores dedicados',
    banners: [
      { image: 'assets/images/rackeo/inicio/bnr-soporte-tecnico.png', url: URL.SUPPORT_CHAT, alt: 'Soporte técnico 24/7 Rackeo' },
      { image: 'assets/images/rackeo/inicio/bnr-uptime.png', url: URL.HAULMER_LEGAL_UPTIME_SLA, alt: 'Garantía de uptime del 99,9%' },
      { image: 'assets/images/rackeo/inicio/bnr-garantia-reembolso.png', url: URL.HAULMER_LEGAL_REFUND, alt: 'Garantía de reembolso a 30 días' }
    ],
    ctaImage: '',
    ctaUrl: '#',
    ctaAlt: 'Necesita Ayuda'
  };

  private readonly defaultContact: RackeoContactData = {
    phoneDisplay: '+56 2 3384 9654',
    phoneTel: '+56233849654',
    phoneKicker: 'Atención cliente',
    chatLabel: 'Portal de solicitudes'
  };

  readonly content$ = this.locale.getContent().pipe(
    map((c) => ({
      home: { ...(c?.home ?? this.defaultHome), banners: this.defaultHome.banners },
      contact: c?.contact ?? this.defaultContact
    }))
  );

  constructor(
    private readonly locale: RackeoLocaleService,
    private readonly meta: MetaService,
    private readonly canonical: CanonicalService
  ) {}

  ngOnInit(): void {
    this.meta.setTitle('Hosting Chile | Web Hosting Pro, VPS y Servidores Dedicados | Rackeo');
    this.meta.setTag('description', 'Rackeo ofrece Web Hosting Pro, VPS Cloud SSD y Servidores Dedicados en Chile con data center propio, soporte 24/7 y uptime garantizado de 99,9%.');
    this.meta.setTag('og:type', 'website');
    this.meta.setTag('og:image:type', 'image/png');
    this.meta.setTag('og:image', RACKEO_SITE.ogImageUrl);
    this.meta.setTag('og:image:width', '1200');
    this.meta.setTag('og:image:height', '1200');
    this.meta.setTag('og:image:alt', 'Hosting Chile | Web Hosting Pro, VPS y Servidores Dedicados | Rackeo');
    this.meta.setTag('og:locale', RACKEO_SITE.ogLocale);
    this.canonical.set('/');
  }

  isInternalUrl(url: string): boolean {
    return /^\/(?!\/)/.test((url || '').trim());
  }
}
